import React from "react";
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;  
`;

export const FlexContainer = styled.div`
  display: flex;
`;
